import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { IAnnouncementModel } from "@models";

@Component({
	selector: "announcement-dialog",
	templateUrl: "./announcement-dialog.component.html",
	styleUrl: "./announcement-dialog.component.css",
	standalone: false
})
export class AnnouncementDialogComponent {
	private _announcement: IAnnouncementModel;
	safeHtml: SafeHtml = "";

	@Input() set announcement(value: IAnnouncementModel) {
		this._announcement = value;
		this.safeHtml = value?.announcementHtml
			? this.sanitizer.bypassSecurityTrustHtml(value.announcementHtml)
			: "";
	}
	get announcement(): IAnnouncementModel { return this._announcement; }

	@Input() isOpen = false;
	@Input() isMobile: boolean = false;

	@Output() onClose = new EventEmitter<void>();

	constructor(private sanitizer: DomSanitizer) { }

	close() {
		this.onClose.emit();
	}
}
